
import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = {
  landingPageData: null,
  title: "",
  layout: 'twocolumn',
  tiles: [],
  dynamicDays: false
}
export const getters = {
  landingPageData: state => state.landingPageData,
  title: state => state.title,
  layout: state => state.layout,
  tiles: state => state.tiles,
  dynamicDays: state => state.dynamicDays
}

export const actions = {
  updateModuleInDB: async ({ state, rootState }) => {
    let content = {
      tweetsRead: state.tweetsRead,
      tweetsUnread: state.tweetsUnread
    }
    await axios.post('/api/updateModule', {
      params: {
        moduleState: content,
        moduleName: MODULES.DASHBOARD,
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
      } 
    })
  },
  populateFromDB: ({ commit, dispatch }, payload) => {
    dispatch('populateDashboardFromDB')
    if (payload) {
      commit('SET_DASHBOARD_USER_CONTENT', payload)
    }
  },
  populateDashboardFromDB: async ({ commit }) => {
    axios.post('/api/pcs/dashboard', {
      params: {
        pcs: localStorage.getItem('pcs')
      }
    }).then(res => {
      commit("SET_DASHBOARD_MODULE_DATA", res.data['settings'])
    })
  },
}

export const mutations = {
  SET_DASHBOARD_MODULE_DATA(state, payload) {
    state.landingPageData = payload.landingPageData ?? null
    state.title = payload.title ?? ""
    state.layout = payload.layout ?? 'twocolumn'
    state.tiles = payload.tiles ?? [],
    state.dynamicDays = payload.dynamicDays ?? false
  },
  SET_DASHBOARD_USER_CONTENT(state, payload) {
    // Set user content here on refresh 
  }
}
